<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card tab2-card">
                <div class="card-body tab2-card">
                    <form [formGroup]="terminateContractForm" class="needs-validation" novalidate>
                        <div class="form-group row">
                            <label>{{identificationNumber}}</label>
                            <div class="col-xl-3 col-md-3">
                                <input class="form-control" formControlName="identificationNumber" type="text" />
                            </div>
                            <label>{{client}}</label>
                            <div class="col-xl-3 col-md-3">
                                <input class="form-control" type="text" formControlName="client" />
                            </div>
                            <label class="bold">{{number}}</label>
                            <div class="col-xl-3 col-md-3">
                                <input class="form-control" type="text" formControlName="number" />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label>{{startDate}}<span>*</span></label>
                            <div class="col-xl-3 col-md-3" (input)="checkStartDate()">
                                <input [ngClass]="onDisplayRequiredField('startDate')" class="form-control" type="date"
                                    [min]="minDate | date:'yyyy-MM-dd'" formControlName="startDate"
                                    onkeydown="return false" required />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label>{{reasonTypeLabel}}<span>*</span></label>
                            <div class="col-xl-3 col-md-3">
                                <select class="form-control digits" formControlName="reasonType"
                                    [ngClass]="onDisplayRequiredField('reasonType')">
                                    <option></option>
                                    <option *ngFor="let option of reasonTypeOptions | keyvalue" [value]="option.key">
                                        {{ option.value }} </option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label>{{reason}}<span>*</span></label>
                            <div class="col-xl-3 col-md-3">
                                <textarea [ngClass]="onDisplayRequiredField('reason')" class="form-control"
                                    formControlName="reason" rows="4"></textarea>
                            </div>
                        </div>
                        <div style="min-height: 72px">
                            <div class="message-24-blue" *ngIf="renouncementMessage">
                                {{renouncementMessage}}
                            </div>
                        </div>
                    </form>
                    <div class="card-footer row pull-right">
                        <button type="button" class="btn btn-primary button-margin" (click)="onCancel()">
                            Renunta
                        </button>
                        <button style="margin-left: 24px;" type="button" class="btn btn-primary button-margin"
                            (click)="onCancelContract()">
                            {{saveButtonText}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>